import { useQuery } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../api/v1";
import { ApiResponse } from "../../../../types/api-response";
import { TenantBankDetails } from "../../../../types/tenants";
import axios from "../../../../utils/axiosInceptor";

type UseGetBankDetailsOptions = {
  tenantId?: string;
  isEnabled?: boolean;
};

const getBankDetails = async (tenantId: string) => {
  const url = `${apiV1Endpoint}/tenant/${tenantId}/bank-details`;
  const response = await axios.get<ApiResponse<TenantBankDetails>>(url);
  return response.data.result;
};

export const useGetBankDetails = (options: UseGetBankDetailsOptions) => {
  const { tenantId, isEnabled = true } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["bank-details", tenantId],
    queryFn: () => getBankDetails(tenantId),
    enabled: Boolean(tenantId) && isEnabled,
  });

  return {
    bankDetails: data,
    isLoadingBankDetails: isLoading,
  };
};
